/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationListSchema
 */
export interface OrganizationListSchema {
    /**
     * 
     * @type {number}
     * @memberof OrganizationListSchema
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationListSchema
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationListSchema
     */
    updated: Date;
    /**
     * 
     * @type {string}
     * @memberof OrganizationListSchema
     */
    name: string;
}

/**
 * Check if a given object implements the OrganizationListSchema interface.
 */
export function instanceOfOrganizationListSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function OrganizationListSchemaFromJSON(json: any): OrganizationListSchema {
    return OrganizationListSchemaFromJSONTyped(json, false);
}

export function OrganizationListSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationListSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'name': json['name'],
    };
}

export function OrganizationListSchemaToJSON(value?: OrganizationListSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'name': value.name,
    };
}

